import { Injectable } from '@angular/core';
import { FeedbackContainerComponent } from '../containers/feedback-container/feedback-container.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { IFeedback } from '../interfaces/IFeedback.interface';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeedbackApiService {
  constructor(private _http: HttpClient) {}

  sendFeedback(model: IFeedback): Observable<IFeedback & { id: number }> {
    return this._http.post<IFeedback & { id: number }>(environment.apiUrl + '/feedback/create/', model);
  }
}
